import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { GlobalFilter } from "../core/core.component";

@Injectable()
export class GlobalFilterService
{

  globalFilter: BehaviorSubject<GlobalFilter> = new BehaviorSubject<GlobalFilter>(null);
  globalFilterStatus: Subject<string> = new Subject();
    

  getGlobalFilter() : Observable<GlobalFilter> {
      return this.globalFilter.asObservable();
  }
  getGlobalFilterStatus() : Observable<string> {
      return this.globalFilterStatus.asObservable();
  }
  
  setGlobalFilter(globalFilter: GlobalFilter) {
      this.globalFilter.next(globalFilter);
  }
  
  openGlobalFilter() {
      this.globalFilterStatus.next("open");
  }

  closeGlobalFilter() {
      this.globalFilterStatus.next("close");
  }
    
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/service/global-filter.service.ts